var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2979 10.3555H21.7054V18.1389H17.2979V10.3555Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7959 10.3555H14.2034V18.1389H9.7959V10.3555Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5494 19.5449C21.8414 19.5449 2.30655 19.5449 1.44962 19.5449C0.673992 19.5449 0.0429688 20.1759 0.0429688 20.9516V22.5927C0.0429688 23.3683 0.673992 23.9993 1.44962 23.9993H22.5494C23.325 23.9993 23.956 23.3683 23.956 22.5927V20.9516C23.956 20.1759 23.325 19.5449 22.5494 19.5449Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0745 4.41591C12.2399 -0.0142423 12.5298 0.104245 12.522 0.101103C12.1877 -0.0326693 11.816 -0.0353888 11.4721 0.103073L0.92447 4.41591C0.388864 4.63141 0.0429688 5.14334 0.0429688 5.72086V7.54224C0.0429688 8.31787 0.673992 8.94889 1.44962 8.94889H22.5494C23.325 8.94889 23.956 8.31787 23.956 7.54224V5.72086C23.956 5.14334 23.6101 4.63141 23.0745 4.41591ZM12.7028 5.24466C12.7028 5.63309 12.3879 5.94799 11.9995 5.94799C11.6111 5.94799 11.2962 5.63309 11.2962 5.24466V3.74424C11.2962 3.35581 11.6111 3.04091 11.9995 3.04091C12.3879 3.04091 12.7028 3.35581 12.7028 3.74424V5.24466Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.29395 10.3555H6.70145V18.1389H2.29395V10.3555Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.37d6e8b7.svg";
export { ForwardRef as ReactComponent };